export const SuperThin = {
  '& .MuiInputBase-root': {
    height: 32,
    fontSize: '0.8rem',
  },
  '& .MuiOutlinedInput-input': {
    padding: '6px 8px',
    fontSize: '0.8rem',
    lineHeight: '1.2em',
  },
  '& .MuiInputLabel-root': {
    fontSize: '0.75rem',
    transform: 'translate(14px, 9px) scale(1)',
  },
  '& .MuiInputLabel-shrink': {
    transform: 'translate(14px, -6px) scale(0.75)',
  },
}
